import { render, staticRenderFns } from "./NameModal.vue?vue&type=template&id=022ac0dc&scoped=true"
import script from "./NameModal.vue?vue&type=script&lang=js"
export * from "./NameModal.vue?vue&type=script&lang=js"
import style0 from "./NameModal.vue?vue&type=style&index=0&id=022ac0dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ac0dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022ac0dc')) {
      api.createRecord('022ac0dc', component.options)
    } else {
      api.reload('022ac0dc', component.options)
    }
    module.hot.accept("./NameModal.vue?vue&type=template&id=022ac0dc&scoped=true", function () {
      api.rerender('022ac0dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/naming/NameModal.vue"
export default component.exports